import * as H from 'history'
import { getColumns } from './columns'

export const getControlledConfig =  (history: H.History, withDetailNavigation: boolean = true) => ({
    header: 'Client Task',
    columns: getColumns(history, withDetailNavigation=withDetailNavigation)
})